import template from './loanqConfigure.template.html';

export default {
  bindings: {
    account: '<',
    organization: '<',
    referral: '<',
    onFinish: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, workflowsService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      this.initialize = () => {
        const acc = ctrl.account || $rootScope.CurrentAccount;
        const orgToken = _.find(acc?.integrations?.loanq?.tokens || [], {
          id:
            ctrl.organization?.externalReferenceId ||
            $rootScope.CurrentOrganization?.externalReferenceId
        });
        const idWorkflow = $rootScope.CurrentOrganization?.integrations?.loanq?.idWorkflow;

        $mdDialog
          .show({
            locals: {
              referral: ctrl.referral,
              tokens: orgToken && orgToken.fl ? orgToken.fl : '',
              idWorkflow
            },
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller(referral, tokens) {
              const self = this;
              self.referral = referral;
              self.isLoading = false;
              self.tokens = tokens;
              self.idWorkflow = idWorkflow || null;
              self.currentIdWorkflow = idWorkflow || null;

              if (self.referral) {
                self.isLoading = true;
                workflowsService.getAvailable({ isActive: true }).then((workflows) => {
                  self.availableWorkflows = workflows;
                  self.isLoading = false;
                });
              }

              self.confirm = () => {
                $mdDialog.hide({ tokens: self.tokens, idWorkflow: self.idWorkflow });
              };
              self.cancel = () => {
                $mdDialog.hide({ tokens: self.tokens, idWorkflow: self.currentIdWorkflow });
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
